export default __webpack_public_path__ + "static/media/tradebook.21ee4a80.svg";